import { useState } from "react";

const useOffice = () => {
  const storedOffice = localStorage.getItem("office");
  let lastOffice = {};
  try {
    lastOffice = JSON.parse(storedOffice);
  } catch (error) {
    lastOffice = {};
  }
  const [currentOffice, setCurrentOffice] = useState(lastOffice || {});

  /**
   * Set the current office
   * @param {Object} office - The office object with id and name
   * @param {boolean|Function} reloadOrCallback - If true, reloads the page.
   *   If false, just updates state/localStorage without reload.
   *   If a function, calls it with the new office instead of reloading.
   */
  const setOffice = (office, reloadOrCallback = true) => {
    if (office && (office.clear || (office.id && office.name))) {
      setCurrentOffice(office);
      localStorage.setItem("office", JSON.stringify(office));
      if (typeof reloadOrCallback === "function") {
        reloadOrCallback(office);
      } else if (reloadOrCallback) {
        window.location.reload();
      }
    }
  };

  const clear = () => {
    localStorage.setItem("office", JSON.stringify({}));
  };

  return [currentOffice, setOffice, clear];
};

export default useOffice;
